<template>
  <div class="form-version__container mt-1">
    <div class="smaller">{{ $i18n.t('form_id') }}: {{ form.idForm }}</div>
    <div class="smaller">{{ $i18n.t('form_date') }}: {{ form.versionDate }}</div>
    <div class="smaller">{{ $i18n.t('form_version') }}: {{ form.formVersion || 1 }}.{{ form.formSubVersion || 0 }}</div>
  </div>
</template>

<script>
/**
 * @class FormVersion
 *
 * @description This component renders information about the version of the Form
 */
export default {
  name: 'form-version',
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isProduction() {
        return process.env.NODE_ENV === 'production'
      },
    }
  },
}
</script>
<style scoped>
.smaller {
  font-size: smaller;
  text-align: start;
}
</style>
